import _ from 'lodash';
import Landing from '../views/Landing.vue';
import About from '../views/About.vue';
import Pricing from '../views/Pricing.vue';
import Thanks from '../views/Thanks.vue';
import FAQ from '../views/FAQ.vue';
import Privacy from '../views/Privacy.vue';
import Terms from '../views/Terms.vue';
import Login from '../views/Login.vue';
import SignUp from '../views/SignUp.vue';
import AcceptInvite from '../views/AcceptInvite.vue';
import NewSurvey from '../views/NewSurvey.vue';
import Surveys from '../views/Surveys.vue';
import Questions from '../views/Questions.vue';
import Answers from '../views/Answers.vue';
import Share from '../views/Share.vue';
import Respondent from '../views/Respondent.vue';
import Respondents from '../views/Respondents.vue';
import Settings from '../views/Settings.vue';
import Feedback from '../views/Feedback.vue';
import SurveyQR from '../views/SurveyQR.vue';
import Error404 from '../views/Error404.vue';

export const routes = [
  {
    path: '/',
    name: 'landing',
    component: Landing,
    meta: {
      requiresLoggedOut: true
    }
  },
  {
    path: '/landing',
    name: 'landing',
    component: Landing
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: Pricing
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQ
  },
  {
    path: '/thanks',
    name: 'thanks',
    component: Thanks
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy
  },
  {
    path: '/terms',
    name: 'terms',
    component: Terms
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      requiresLoggedOut: true
    }
  },
  {
    path: '/signup',
    name: 'signUp',
    component: SignUp,
    meta: {
      requiresLoggedOut: true
    }
  },
  {
    path: '/invite',
    name: 'acceptInvite',
    component: AcceptInvite,
  },
  {
    path: '/new-survey',
    name: 'newSurvey',
    component: NewSurvey,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/surveys',
    name: 'surveys',
    component: Surveys,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/surveys/:survey_index/questions',
    name: 'questions',
    component: Questions,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/surveys/:survey_index/questions/:question_index',
    name: 'answers',
    component: Answers,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/surveys/:survey_index/share',
    name: 'share',
    component: Share,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/surveys/:survey_index/users',
    name: 'respondents',
    component: Respondents,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/surveys/:survey_index/users/:uid',
    name: 'respondent',
    component: Respondent,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: Feedback,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/404',
    name: '404',
    component: Error404
  },
  {
    path: '/qr',
    name: 'surveyQR',
    component: SurveyQR
  },
  {
    path: '*',
    redirect: '/404'
  }
]
